// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  InvoiceLifecycleFilter,
  getInvoiceLifecycleSummary,
} from '@/billing/api/get-invoice-lifecycle-summary';
import { TWO_MINUTES_MS } from '@/utilities/time-constants';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

// Fetches the 6-segment summary (charge lag, invoice review, delivery lag,
// average terms, avg delinquency, total cycle) for the billing lifecycle
// report's cards. Cache key includes window + customer/project keys so the
// cards only refetch when scope-affecting filters change — pagination,
// sort, and search on the detail table leave the summary alone.
export function useInvoiceLifecycleSummary(filter: InvoiceLifecycleFilter) {
  const { data, isLoading, isFetching, isError } = useQuery({
    queryKey: [
      'invoice-summary',
      'lifecycle',
      filter.windowDays ?? null,
      filter.customerKeys ?? [],
      filter.projectKeys ?? [],
    ],
    queryFn: () => getInvoiceLifecycleSummary(filter),
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: true,
    refetchInterval: TWO_MINUTES_MS,
  });

  return {
    summary: data ?? null,
    isLoading,
    isFetching,
    isError,
  };
}
